/* ============================================
   GG SHOPIFY THEME — theme.js
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ─── ANNOUNCEMENT BAR ─────────────────────── */
  const slides = document.querySelectorAll('.announcement-bar__slide');
  if (slides.length > 0) {
    let current = 0;
    slides[0].classList.add('active');
    setInterval(() => {
      slides[current].classList.remove('active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('active');
    }, 3500);
  }

  /* ─── MOBILE MENU ──────────────────────────── */
  const hamburger = document.getElementById('hamburger-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileOverlay = document.getElementById('mobile-menu-overlay');
  const mobileClose = document.getElementById('mobile-menu-close');

  function openMobileMenu() {
    mobileMenu.classList.add('open');
    mobileOverlay.classList.add('active');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    mobileMenu.classList.remove('open');
    mobileOverlay.classList.remove('active');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (hamburger) hamburger.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  /* Accordion in mobile menu */
  document.querySelectorAll('.accordion-trigger').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.accordion-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ─── HERO SLIDER ──────────────────────────── */
  const heroTrack = document.querySelector('.hero-slider__track');
  const heroSlides = document.querySelectorAll('.hero-slide');
  const heroDots = document.querySelectorAll('.hero-dot');
  let heroIndex = 0, heroTimer;

  function goToSlide(n) {
    heroIndex = (n + heroSlides.length) % heroSlides.length;
    if (heroTrack) heroTrack.style.transform = `translateX(-${heroIndex * 100}%)`;
    heroDots.forEach((d, i) => d.classList.toggle('active', i === heroIndex));
  }

  if (heroSlides.length > 1) {
    heroTimer = setInterval(() => goToSlide(heroIndex + 1), 4000);
    heroDots.forEach((dot, i) => dot.addEventListener('click', () => { clearInterval(heroTimer); goToSlide(i); heroTimer = setInterval(() => goToSlide(heroIndex + 1), 4000); }));

    /* Touch swipe on hero */
    let touchStartX = 0;
    const heroSlider = document.querySelector('.hero-slider');
    if (heroSlider) {
      heroSlider.addEventListener('touchstart', e => { touchStartX = e.changedTouches[0].clientX; }, { passive: true });
      heroSlider.addEventListener('touchend', e => {
        const diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) { clearInterval(heroTimer); goToSlide(heroIndex + (diff > 0 ? 1 : -1)); heroTimer = setInterval(() => goToSlide(heroIndex + 1), 4000); }
      }, { passive: true });
    }
  }

  /* ─── CATEGORY ICONS ───────────────────────── */
  document.querySelectorAll('.category-icon-item').forEach(item => {
    item.addEventListener('click', () => {
      document.querySelectorAll('.category-icon-item').forEach(i => i.classList.remove('active'));
      item.classList.add('active');
    });
  });

  /* ─── CART DRAWER ──────────────────────────── */
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartClose = document.getElementById('cart-drawer-close');

  function openCart() {
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('active');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('active');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  document.querySelectorAll('.header-cart-btn, [data-cart-trigger]').forEach(btn => {
    btn.addEventListener('click', e => { e.preventDefault(); openCart(); });
  });

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCart(cart);
    } catch (e) { console.warn('Cart fetch failed', e); }
  }

  function renderCart(cart) {
    const container = document.getElementById('cart-items-container');
    const totalEl = document.getElementById('cart-total-price');
    const fillEl = document.getElementById('delivery-fill');
    const textEl = document.getElementById('delivery-text');
    const badges = document.querySelectorAll('.cart-count-badge');
    const checkoutWrap = document.querySelector('.cart-drawer-checkout');
    const checkoutHelper = document.getElementById('cart-drawer-min-helper');
    if (!container) return;

    const freeThreshold = 499900; // ₹4999 in paise
    const pct = Math.min((cart.total_price / freeThreshold) * 100, 100);
    if (fillEl) fillEl.style.width = pct + '%';
    if (textEl) {
      if (cart.total_price >= freeThreshold) {
        textEl.innerHTML = '🎉 You qualify for <strong>FREE delivery!</strong>';
      } else {
        const remaining = ((freeThreshold - cart.total_price) / 100).toFixed(0);
        textEl.innerHTML = `Add <strong>₹${remaining}</strong> more for <strong>FREE delivery 🚚</strong>`;
      }
    }

    badges.forEach(b => {
      b.textContent = cart.item_count;
      b.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
    if (totalEl) totalEl.textContent = '₹' + (cart.total_price / 100).toLocaleString('en-IN');

    if (checkoutWrap) {
      const minValue = parseInt(checkoutWrap.dataset.minCheckout || '500', 10);
      const minPaise = Number.isFinite(minValue) ? minValue * 100 : 50000;
      const isDisabled = cart.item_count === 0 || cart.total_price < minPaise;
      checkoutWrap.classList.toggle('is-disabled', isDisabled);
      checkoutWrap.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');

      const checkoutBtn = checkoutWrap.querySelector('button, a');
      if (checkoutBtn) {
        if (isDisabled) {
          checkoutBtn.setAttribute('aria-disabled', 'true');
          checkoutBtn.classList.add('disabled');
          if (checkoutBtn.tagName === 'BUTTON') checkoutBtn.setAttribute('disabled', 'disabled');
          if (checkoutBtn.tagName === 'A') checkoutBtn.setAttribute('tabindex', '-1');
        } else {
          checkoutBtn.removeAttribute('aria-disabled');
          checkoutBtn.classList.remove('disabled');
          if (checkoutBtn.tagName === 'BUTTON') checkoutBtn.removeAttribute('disabled');
          if (checkoutBtn.tagName === 'A') checkoutBtn.removeAttribute('tabindex');
        }
      }
      if (checkoutHelper) {
        checkoutHelper.textContent = `Minimum order value is ₹${Number.isFinite(minValue) ? minValue : 500}`;
        checkoutHelper.hidden = !isDisabled;
      }
    }

    if (cart.items.length === 0) {
      container.innerHTML = `<div class="cart-empty"><span>🌱</span><p>Your cart is empty.<br>Add some plants!</p></div>`;
      return;
    }

    container.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item__img">
          <img src="${item.image}" alt="${item.product_title}" loading="lazy">
        </div>
        <div class="cart-item__info">
          <div class="cart-item__name">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div style="font-size:11px;color:var(--text-light)">${item.variant_title}</div>` : ''}
          <div class="cart-item__price">₹${(item.final_price / 100).toLocaleString('en-IN')}</div>
          <div class="cart-item__qty">
            <button class="qty-btn" onclick="updateCartItem('${item.key}', ${item.quantity - 1})">−</button>
            <span class="qty-display">${item.quantity}</span>
            <button class="qty-btn" onclick="updateCartItem('${item.key}', ${item.quantity + 1})">+</button>
          </div>
          <span class="cart-item__remove" onclick="updateCartItem('${item.key}', 0)">Remove</span>
        </div>
      </div>
    `).join('');
  }

  window.updateCartItem = async function (key, qty) {
    await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    refreshCart();
  };

  // Prevent checkout clicks when disabled (cart drawer)
  document.addEventListener('click', function (e) {
    const wrap = e.target.closest('.cart-drawer-checkout');
    if (!wrap) return;
    if (!wrap.classList.contains('is-disabled')) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
  }, true);

  /* ─── ADD TO CART BUTTONS ──────────────────── */
  document.addEventListener('click', async function (e) {
    const addBtn = e.target.closest('[data-add-to-cart]');
    if (!addBtn) return;
    const variantId = addBtn.dataset.variantId;
    if (!variantId) return;

    if (addBtn.disabled) return;
    addBtn.disabled = true;
    const originalText = addBtn.innerHTML;
    addBtn.innerHTML = '<span class="btn-spinner"></span> Adding...';

    // Clear any previous inline errors
    const existingError = addBtn.nextElementSibling;
    if (existingError && existingError.classList.contains('atc-inline-error')) {
      existingError.remove();
    }

    try {
      // Check if we are on PDP and get quantity
      const pdpQty = document.querySelector('.pdp-qty-display');
      const quantity = pdpQty ? parseInt(pdpQty.textContent) : 1;

      // Optimistic Update: Increment cart badges
      const badges = document.querySelectorAll('.cart-count-badge');
      badges.forEach(b => {
        const currentCount = parseInt(b.textContent) || 0;
        b.textContent = currentCount + quantity;
        b.style.display = 'flex';
        b.classList.add('pop');
        setTimeout(() => b.classList.remove('pop'), 300);
      });

      const body = JSON.stringify({
        id: variantId,
        quantity: quantity
      });

      const res = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: body
      });

      if (!res.ok) throw new Error('Failed to add to cart');

      // Success State
      showToast('Added to cart ✓');
      addBtn.innerHTML = originalText;
      addBtn.disabled = false;

      refreshCart();
    } catch (err) {
      // Failure State
      const pdpQty = document.querySelector('.pdp-qty-display');
      const quantity = pdpQty ? parseInt(pdpQty.textContent) : 1;

      const badges = document.querySelectorAll('.cart-count-badge');
      badges.forEach(b => {
        const currentCount = parseInt(b.textContent) || 0;
        const newCount = Math.max(0, currentCount - quantity);
        b.textContent = newCount;
        b.style.display = newCount > 0 ? 'flex' : 'none';
      });

      addBtn.innerHTML = originalText;
      addBtn.disabled = false;
      showInlineError(addBtn, 'Failed to add. Please try again.');
    }
  });

  function showToast(message) {
    let toastContainer = document.getElementById('toast-container');
    if (!toastContainer) {
      toastContainer = document.createElement('div');
      toastContainer.id = 'toast-container';
      document.body.appendChild(toastContainer);
    }
    const toast = document.createElement('div');
    toast.className = 'toast';
    toast.textContent = message;
    toastContainer.appendChild(toast);

    // Trigger reflow to ensure transition works
    void toast.offsetWidth;
    toast.classList.add('show');

    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  }

  function showInlineError(btn, message) {
    const errorEl = document.createElement('div');
    errorEl.className = 'atc-inline-error';
    errorEl.textContent = message;

    // Insert after the button
    if (btn.nextSibling) {
      btn.parentNode.insertBefore(errorEl, btn.nextSibling);
    } else {
      btn.parentNode.appendChild(errorEl);
    }

    setTimeout(() => {
      errorEl.style.opacity = '0';
      errorEl.style.transition = 'opacity 0.3s ease';
      setTimeout(() => errorEl.remove(), 300);
    }, 4000);
  }

  /* ─── STORES TABS ──────────────────────────── */
  document.querySelectorAll('.store-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      const store = tab.dataset.store;
      document.querySelectorAll('.store-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      document.querySelectorAll('.store-panel').forEach(p => {
        p.style.display = p.dataset.store === store ? 'block' : 'none';
      });
    });
  });

  /* ─── FOOTER ACCORDION ─────────────────────── */
  document.querySelectorAll('.footer-section__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const section = trigger.closest('.footer-section');
      section.classList.toggle('open');
    });
  });

  /* ─── PRODUCT DESCRIPTION ACCORDION ────────── */
  document.querySelectorAll('.accordion-block__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const block = trigger.closest('.accordion-block');
      block.classList.toggle('open');
    });
  });

  /* ─── PRODUCT GALLERY (PDP) ─────────────────── */
  document.querySelectorAll('.gallery-thumb').forEach((thumb, idx) => {
    thumb.addEventListener('click', () => {
      const src = thumb.querySelector('img').src;
      const mainImg = document.querySelector('.product-gallery__main img');
      if (mainImg) mainImg.src = src;
      document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  /* ─── VARIANT SELECTOR (PDP) ────────────────── */
  document.querySelectorAll('.variant-pill').forEach(pill => {
    pill.addEventListener('click', () => {
      const parent = pill.closest('.variant-pills');
      parent.querySelectorAll('.variant-pill').forEach(p => p.classList.remove('active'));
      pill.classList.add('active');

      const variantId = pill.dataset.variantId;
      const priceRaw = parseInt(pill.dataset.priceRaw);
      const compareRaw = parseInt(pill.dataset.compareRaw);
      const available = pill.dataset.available === 'true';

      // Update all ATC buttons
      document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
        btn.dataset.variantId = variantId;
        if (available) {
          btn.disabled = false;
          btn.style.opacity = '1';
          btn.textContent = btn.classList.contains('btn-primary') ? 'Add to Cart' : '🛒 Add to Cart';
        } else {
          btn.disabled = true;
          btn.style.opacity = '0.6';
          btn.textContent = 'Sold Out';
        }
      });

      // Update Price & Savings
      const priceEl = document.getElementById('pdp-price');
      const compareEl = document.getElementById('pdp-compare-price');
      const savingsEl = document.getElementById('pdp-savings');

      if (priceEl) priceEl.textContent = pill.dataset.price;

      if (compareEl && compareRaw > priceRaw) {
        compareEl.textContent = pill.dataset.compare;
        compareEl.style.display = '';
        if (savingsEl) {
          const savings = Math.round((compareRaw - priceRaw) * 100 / compareRaw);
          savingsEl.textContent = savings + '% OFF';
          savingsEl.style.display = '';
        }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (savingsEl) savingsEl.style.display = 'none';
      }

      // Update Buy Now links
      updateBuyNowLinks();
    });
  });

  /* ─── PINCODE CHECKER (#10) ──────────────────── */
  const pinBtn = document.getElementById('pincode-check-btn');
  const pinInput = document.getElementById('pincode-input');
  const pinResult = document.getElementById('pincode-result');

  if (pinBtn && pinInput && pinResult) {
    pinBtn.addEventListener('click', () => {
      const code = pinInput.value.trim();
      if (code.length < 6) {
        pinResult.style.color = '#e74c3c';
        pinResult.textContent = '❌ Please enter a valid 6-digit pincode';
        pinResult.style.display = 'block';
        return;
      }
      pinBtn.textContent = 'Checking...';
      setTimeout(() => {
        pinBtn.textContent = 'Check';
        pinResult.style.color = '#27ae60';
        pinResult.textContent = '✅ Delivery available for ' + code + ' (Expected within 3-5 days)';
        pinResult.style.display = 'block';
      }, 800);
    });
  }

  /* ─── MOBILE GALLERY SWIPE (#14) ─────────────── */
  const galleryMain = document.querySelector('.product-gallery__main');
  if (galleryMain && window.innerWidth < 768) {
    let startX = 0;
    galleryMain.addEventListener('touchstart', e => startX = e.touches[0].clientX);
    galleryMain.addEventListener('touchend', e => {
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      if (Math.abs(diff) > 50) {
        const thumbs = Array.from(document.querySelectorAll('.gallery-thumb'));
        const activeIdx = thumbs.findIndex(t => t.classList.contains('active'));
        let nextIdx = diff > 0 ? activeIdx + 1 : activeIdx - 1;
        if (nextIdx >= 0 && nextIdx < thumbs.length) {
          thumbs[nextIdx].click();
        }
      }
    });
  }

  /* ─── QUANTITY STEPPER (PDP) ─────────────────── */
  const pdpQtyBtns = document.querySelectorAll('.pdp-qty-btn');
  pdpQtyBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const display = document.querySelector('.pdp-qty-display');
      if (!display) return;
      let qty = parseInt(display.textContent) || 1;
      qty = btn.dataset.action === 'inc' ? qty + 1 : Math.max(1, qty - 1);
      display.textContent = qty;
      updateBuyNowLinks();
    });
  });

  /* ─── BUY NOW LINK UPDATER (#2) ──────────────── */
  function updateBuyNowLinks() {
    const activeVariant = document.querySelector('.variant-pill.active');
    const variantId = activeVariant ? activeVariant.dataset.variantId : '';
    const qty = parseInt(document.querySelector('.pdp-qty-display')?.textContent) || 1;
    document.querySelectorAll('[data-buy-now]').forEach(link => {
      link.href = '/checkout?variant=' + variantId + '&quantity=' + qty;
    });
  }

  /* ─── STICKY BAR OBSERVER (#24) ──────────────── */
  const stickyAnchor = document.querySelector('.product-info__atc-row');
  const stickyBar = document.getElementById('pdp-sticky');
  if (stickyAnchor && stickyBar && window.innerWidth < 1024) {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        stickyBar.style.transform = 'translateY(100%)';
      } else {
        stickyBar.style.transform = 'translateY(0)';
      }
    }, { threshold: 0.1 });
    observer.observe(stickyAnchor);
  }

  /* ─── COUPON CLIPPING ───────────────────────── */
  document.querySelectorAll('.pdp-offer-card').forEach(card => {
    const action = card.querySelector('.pdp-offer__action');
    if (action) {
      action.addEventListener('click', () => {
        const code = action.dataset.code;
        if (code) {
          navigator.clipboard.writeText(code).then(() => {
            const originalText = action.textContent;
            action.textContent = '✓ Copied!';
            setTimeout(() => { action.textContent = originalText; }, 2000);
          });
        }
      });
    }
  });

  /* ─── SOCIAL PROOF (#21) ─────────────────────── */
  const soldBadge = document.querySelector('.pdp-sold-badge');
  if (soldBadge) {
    const productId = parseInt(soldBadge.dataset.productId) || 0;
    const seededRand = (seed, min, max) => {
      const x = Math.sin(seed + 1) * 10000;
      return min + Math.floor((x - Math.floor(x)) * (max - min + 1));
    };

    const soldEl = document.getElementById('pdp-sold-count');
    if (soldEl) soldEl.textContent = seededRand(productId % 9999, 8, 47);

    const viewerEl = document.getElementById('pdp-viewer-count');
    if (viewerEl) {
      let viewers = seededRand((productId % 9999) + 7, 6, 19);
      viewerEl.textContent = viewers;
      setInterval(() => {
        const drift = Math.floor(Math.random() * 5) - 2;
        viewers = Math.min(22, Math.max(4, viewers + drift));
        viewerEl.textContent = viewers;
      }, 25000);
    }
  }

  /* ─── LAZY LOAD IMAGES ─────────────────────── */
  if ('IntersectionObserver' in window) {
    const lazyImgs = document.querySelectorAll('img[loading="lazy"]');
    const imgObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) { img.src = img.dataset.src; delete img.dataset.src; }
          imgObserver.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });
    lazyImgs.forEach(img => imgObserver.observe(img));
  }

  /* ─── PRODUCT RECOMMENDATIONS (PDP) ─────────── */
  const recsRoot = document.getElementById('product-recommendations-root');
  if (recsRoot) {
    const productId = recsRoot.dataset.productId;
    const sectionId = recsRoot.dataset.sectionId;
    const limit = recsRoot.dataset.limit || 6;
    const url = `/recommendations/products?product_id=${productId}&section_id=${sectionId}&limit=${limit}`;

    fetch(url)
      .then(res => {
        if (!res.ok) throw new Error('Recommendations fetch failed');
        return res.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const content = doc.querySelector('.shopify-section');
        if (content && content.innerHTML.trim().length > 0) {
          recsRoot.innerHTML = content.innerHTML;
        }
      })
      .catch(err => console.warn('Product recommendations:', err));
  }

  /* ─── PREDICTIVE SEARCH ─────────────────────── */
  const predictiveSearchContainers = document.querySelectorAll('[data-predictive-search]');
  
  predictiveSearchContainers.forEach(container => {
    const input = container.querySelector('[data-predictive-search-input]');
    const resultsContainer = container.querySelector('[data-predictive-search-results]');
    let debounceTimer;

    if (!input || !resultsContainer) return;

    input.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      const query = input.value.trim();

      if (query.length < 2) {
        closePredictiveSearch(resultsContainer);
        return;
      }

      debounceTimer = setTimeout(() => {
        fetchPredictiveSearch(query, resultsContainer);
      }, 300);
    });

    // ESC key handled below; outside-click handled by shared listener

    // Handle ESC key
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closePredictiveSearch(resultsContainer);
        input.blur();
      }
    });
  });

  // Single shared listener — closes whichever results panel is open
  document.addEventListener('click', (e) => {
    predictiveSearchContainers.forEach(container => {
      if (!container.contains(e.target)) {
        const rc = container.querySelector('[data-predictive-search-results]');
        if (rc) closePredictiveSearch(rc);
      }
    });
  });

  function closePredictiveSearch(resultsContainer) {
    resultsContainer.innerHTML = '';
    resultsContainer.classList.remove('active');
  }

  async function fetchPredictiveSearch(query, resultsContainer) {
    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,query&resources[limit]=6`);
      if (!response.ok) return;
      const data = await response.json();
      renderPredictiveSearchResults(data, query, resultsContainer);
    } catch (error) {
      console.error('Predictive search fetch failed:', error);
    }
  }

  function renderPredictiveSearchResults(data, query, resultsContainer) {
    const products = data.resources.results.products || [];
    const queries = data.resources.results.queries || [];

    if (products.length === 0 && queries.length === 0) {
      resultsContainer.innerHTML = '<div class="predictive-search__no-results">No results found</div>';
    } else {
      let html = '';

      if (queries.length > 0) {
        html += `<div class="predictive-search__section">
          <h3 class="predictive-search__heading">SEARCH SUGGESTIONS</h3>
          <ul class="predictive-search__list">
            ${queries.map(q => `
              <li class="predictive-search__list-item">
                <a href="${q.url}" class="predictive-search__item-link">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
                  <span>${q.text}</span>
                </a>
              </li>
            `).join('')}
          </ul>
        </div>`;
      }

      if (products.length > 0) {
        html += `<div class="predictive-search__section">
          <h3 class="predictive-search__heading">SEARCH RESULTS</h3>
          <div class="predictive-search__grid">
            ${products.map(p => `
              <a href="${p.url}" class="predictive-search__product-card">
                <div class="predictive-search__product-img">
                  <img src="${p.image}" alt="${p.title}" loading="lazy">
                </div>
                <div class="predictive-search__product-info">
                  <div class="predictive-search__product-title">${p.title}</div>
                  <div class="predictive-search__product-price">
                    ${p.compare_at_price_max > p.price_min ? `<span class="predictive-search__price-compare">₹${(p.compare_at_price_max / 100).toLocaleString('en-IN')}</span>` : ''}
                    <span class="predictive-search__price-current">From ₹${(p.price_min / 100).toLocaleString('en-IN')}</span>
                  </div>
                </div>
              </a>
            `).join('')}
          </div>
        </div>`;
      }

      html += `<div class="predictive-search__footer">
        <a href="/search?q=${encodeURIComponent(query)}&options[prefix]=last" class="predictive-search__view-all">
          View All ${products.length > 0 ? `(${products.length})` : ''} &rarr;
        </a>
      </div>`;

      resultsContainer.innerHTML = html;
    }

    resultsContainer.classList.add('active');
  }

  /* ─── INIT: badge-only cart count on load ────── */
  // Only update the count badge — skip rendering the full cart drawer
  // Full renderCart() still runs when the drawer is actually opened
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const badges = document.querySelectorAll('.cart-count-badge');
      badges.forEach(b => {
        b.textContent = cart.item_count;
        b.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    })
    .catch(() => {});
});

/* ============================================
   QUICK VIEW MODULE
   ============================================ */
(function () {

  /* ── Create overlay once ── */
  const overlay = document.createElement('div');
  overlay.id = 'qv-overlay';
  overlay.className = 'qv-overlay';
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-label', 'Quick View');
  overlay.innerHTML = `<div class="qv-modal" id="qv-modal"></div>`;
  document.body.appendChild(overlay);

  const modal = overlay.querySelector('#qv-modal');

  /* ── State ── */
  let currentProduct = null;
  let selectedVariant = null;
  let qvQty = 1;

  /* ── Format money (paise → ₹) ── */
  function formatMoney(paise) {
    return '₹' + (paise / 100).toLocaleString('en-IN');
  }

  /* ── Open / close ── */
  function openModal() {
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    overlay.focus();
  }

  function closeModal() {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
    currentProduct = null;
    selectedVariant = null;
    qvQty = 1;
  }

  /* ── Show loading skeleton ── */
  function showSkeleton() {
    modal.innerHTML = `
      <button class="qv-close" id="qv-close-btn" aria-label="Close Quick View">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
      <div style="background:var(--green-bg);border-radius:16px 0 0 16px;aspect-ratio:1/1;" class="qv-skel"></div>
      <div class="qv-skeleton">
        <div class="qv-skel" style="height:12px;width:60px;"></div>
        <div class="qv-skel" style="height:22px;width:85%;"></div>
        <div class="qv-skel" style="height:22px;width:60%;"></div>
        <div class="qv-skel" style="height:28px;width:40%;"></div>
        <div class="qv-skel" style="height:14px;width:50px;margin-top:8px;"></div>
        <div style="display:flex;gap:8px;">
          <div class="qv-skel" style="height:34px;width:70px;border-radius:50px;"></div>
          <div class="qv-skel" style="height:34px;width:70px;border-radius:50px;"></div>
          <div class="qv-skel" style="height:34px;width:70px;border-radius:50px;"></div>
        </div>
        <div class="qv-skel" style="height:44px;width:100%;margin-top:auto;border-radius:8px;"></div>
      </div>`;
    bindClose();
  }

  /* ── Render full modal ── */
  function renderModal(product, productUrl) {
    currentProduct = product;
    const variants = product.variants;
    selectedVariant = variants.find(v => v.available) || variants[0];
    qvQty = 1;

    const images = product.images;
    const options = product.options;
    const hasOptions = !(options.length === 1 && options[0].name === 'Title');

    /* Image panel */
    const mainSrc = images[0] ? images[0].src.replace(/(\.[a-z]+)$/, '_600x600$1') : '';
    const thumbsHTML = images.slice(0, 5).map((img, i) => {
      const src = img.src.replace(/(\.[a-z]+)$/, '_120x120$1');
      return `<div class="qv-thumb ${i === 0 ? 'active' : ''}" data-src="${img.src.replace(/(\.[a-z]+)$/, '_600x600$1')}">
        <img src="${src}" alt="${product.title}" loading="lazy">
      </div>`;
    }).join('');

    /* Price */
    const price = formatMoney(selectedVariant.price);
    const compare = selectedVariant.compare_at_price > selectedVariant.price
      ? formatMoney(selectedVariant.compare_at_price) : '';
    const savePct = compare
      ? Math.round((selectedVariant.compare_at_price - selectedVariant.price) * 100 / selectedVariant.compare_at_price)
      : 0;

    /* Variants — one set of pills per option */
    let variantsHTML = '';
    if (hasOptions) {
      options.forEach((opt, optIdx) => {
        const values = [...new Set(variants.map(v => v.options[optIdx]))];
        const pillsHTML = values.map(val => {
          const available = variants.some(v => v.options[optIdx] === val && v.available);
          const isActive = selectedVariant.options[optIdx] === val;
          return `<button class="qv-pill ${isActive ? 'active' : ''} ${!available ? 'unavailable' : ''}"
                    data-opt-index="${optIdx}" data-opt-val="${val}"
                    ${!available ? 'disabled' : ''}>${val}</button>`;
        }).join('');
        variantsHTML += `
          <div class="qv-option">
            <div class="qv-option__label">${opt.name}:
              <strong id="qv-opt-val-${optIdx}">${selectedVariant.options[optIdx]}</strong>
            </div>
            <div class="qv-pills">${pillsHTML}</div>
          </div>`;
      });
    }

    /* ATC button state */
    const atcDisabled = !selectedVariant.available;
    const atcLabel = atcDisabled ? 'Sold Out' : '🛒 Add to Cart';

    modal.innerHTML = `
      <button class="qv-close" id="qv-close-btn" aria-label="Close Quick View">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>

      <!-- Image panel -->
      <div class="qv-image" id="qv-image-panel">
        ${mainSrc ? `<img id="qv-main-img" src="${mainSrc}" alt="${product.title}">` : '<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:56px;">🌿</div>'}
        ${images.length > 1 ? `<div class="qv-thumbs">${thumbsHTML}</div>` : ''}
      </div>

      <!-- Info panel -->
      <div class="qv-info">
        <span class="qv-tag">${product.type || product.vendor || ''}</span>
        <h2 class="qv-title">${product.title}</h2>

        <div class="qv-price" id="qv-price-block">
          <span class="qv-price__current" id="qv-price">${price}</span>
          ${compare ? `<span class="qv-price__compare" id="qv-compare">${compare}</span>
          <span class="qv-price__badge">${savePct}% OFF</span>` : ''}
        </div>

        ${variantsHTML}

        <!-- Qty + ATC -->
        <div class="qv-atc-row">
          <div class="qv-qty">
            <button class="qv-qty__btn" id="qv-qty-dec" aria-label="Decrease quantity">−</button>
            <span class="qv-qty__num" id="qv-qty-num">1</span>
            <button class="qv-qty__btn" id="qv-qty-inc" aria-label="Increase quantity">+</button>
          </div>
          <button class="qv-atc btn" id="qv-atc-btn"
            ${atcDisabled ? 'disabled' : ''}
            data-variant-id="${selectedVariant.id}">
            ${atcLabel}
          </button>
        </div>

        <a href="${productUrl}" class="qv-full-link">View Full Details →</a>
      </div>`;

    bindClose();
    bindThumbs();
    bindVariantPills(variants, options);
    bindQty();
    bindATC();
  }

  /* ── Bind close ── */
  function bindClose() {
    document.getElementById('qv-close-btn')?.addEventListener('click', closeModal);
  }

  /* ── Thumbnail switcher ── */
  function bindThumbs() {
    modal.querySelectorAll('.qv-thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        modal.querySelectorAll('.qv-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const mainImg = document.getElementById('qv-main-img');
        if (mainImg) mainImg.src = thumb.dataset.src;
      });
    });
  }

  /* ── Variant pill selection ── */
  function bindVariantPills(variants, options) {
    modal.querySelectorAll('.qv-pill').forEach(pill => {
      pill.addEventListener('click', () => {
        const optIdx = parseInt(pill.dataset.optIndex);
        const optVal = pill.dataset.optVal;

        /* Update active pill for this option */
        modal.querySelectorAll(`.qv-pill[data-opt-index="${optIdx}"]`)
          .forEach(p => p.classList.remove('active'));
        pill.classList.add('active');

        /* Update label */
        const label = document.getElementById(`qv-opt-val-${optIdx}`);
        if (label) label.textContent = optVal;

        /* Find matching variant */
        const selectedOptions = options.map((_, i) => {
          const activePill = modal.querySelector(`.qv-pill[data-opt-index="${i}"].active`);
          return activePill ? activePill.dataset.optVal : selectedVariant.options[i];
        });

        const matched = variants.find(v =>
          v.options.every((o, i) => o === selectedOptions[i])
        );

        if (matched) {
          selectedVariant = matched;
          /* Update price */
          document.getElementById('qv-price').textContent = formatMoney(matched.price);
          const compareEl = document.getElementById('qv-compare');
          if (compareEl) compareEl.textContent = matched.compare_at_price > matched.price ? formatMoney(matched.compare_at_price) : '';
          /* Update ATC */
          const atcBtn = document.getElementById('qv-atc-btn');
          if (atcBtn) {
            atcBtn.dataset.variantId = matched.id;
            atcBtn.disabled = !matched.available;
            atcBtn.textContent = matched.available ? '🛒 Add to Cart' : 'Sold Out';
          }
        }
      });
    });
  }

  /* ── Qty stepper ── */
  function bindQty() {
    document.getElementById('qv-qty-dec')?.addEventListener('click', () => {
      if (qvQty > 1) { qvQty--; document.getElementById('qv-qty-num').textContent = qvQty; }
    });
    document.getElementById('qv-qty-inc')?.addEventListener('click', () => {
      qvQty++;
      document.getElementById('qv-qty-num').textContent = qvQty;
    });
  }

  /* ── Add to Cart ── */
  function bindATC() {
    document.getElementById('qv-atc-btn')?.addEventListener('click', async function () {
      const btn = this;
      const variantId = btn.dataset.variantId;
      if (!variantId || btn.disabled) return;

      btn.disabled = true;
      const original = btn.innerHTML;
      btn.innerHTML = '<span class="btn-spinner"></span> Adding...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qvQty })
        });
        if (!res.ok) throw new Error();

        /* Update badges */
        const cart = await fetch('/cart.js').then(r => r.json());
        document.querySelectorAll('.cart-count-badge').forEach(b => {
          b.textContent = cart.item_count;
          b.style.display = cart.item_count > 0 ? 'flex' : 'none';
          b.classList.add('pop');
          setTimeout(() => b.classList.remove('pop'), 300);
        });

        btn.innerHTML = '✓ Added!';
        btn.style.background = 'var(--green-dark)';
        setTimeout(() => {
          btn.innerHTML = original;
          btn.style.background = '';
          btn.disabled = false;
          closeModal();
        }, 1200);

        /* Show toast */
        if (typeof showToast === 'function') showToast('Added to cart ✓');

      } catch {
        btn.innerHTML = original;
        btn.disabled = false;
        btn.style.background = 'var(--red-sale)';
        btn.textContent = 'Failed — Try again';
        setTimeout(() => { btn.style.background = ''; }, 2000);
      }
    });
  }

  /* ── Event delegation — trigger on any [data-quickview] click ── */
  document.addEventListener('click', async function (e) {
    /* Stop clicks inside modal propagating to overlay */
    if (e.target.closest('#qv-modal')) return;

    /* Close on overlay backdrop click */
    if (e.target === overlay) { closeModal(); return; }

    const trigger = e.target.closest('[data-quickview]');
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = trigger.dataset.handle;
    const productUrl = trigger.dataset.url || `/products/${handle}`;
    if (!handle) return;

    showSkeleton();
    openModal();

    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error('Product fetch failed');
      const product = await res.json();
      renderModal(product, productUrl);
    } catch (err) {
      modal.innerHTML = `
        <button class="qv-close" id="qv-close-btn" aria-label="Close">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
        <div style="grid-column:1/-1;padding:40px;text-align:center;">
          <p style="font-size:32px;margin-bottom:12px;">⚠️</p>
          <p style="color:var(--text-mid);">Could not load product. <a href="${productUrl}" style="color:var(--green-mid);text-decoration:underline;">View full page →</a></p>
        </div>`;
      bindClose();
    }
  });

  /* ── ESC key closes modal ── */
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && overlay.classList.contains('active')) closeModal();
  });

})();
